import React, {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import {FormControl, FormLabel, Radio, RadioGroup, Stack} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputField from "../../components/InputField";
import {BASE_URL, BUSINESS} from "../../constants";
import {reportErrors} from "../../helpers";
import AlertBar from "../../components/AlertBar";
import SelectField from "../../components/SelectField";
import Divider from "@mui/material/Divider";

export default function ReviewForm(props) {
    const alert = useRef();
    const [data, setData] = useState([]);
    const [businessType, setBusinessType] = useState();

    useEffect(() => {
        loadData();
    }, [businessType]);
    const loadData = () => {
        let url = `${BASE_URL}api/review-form?data=data`;
        if (businessType) {
            url += `&businessType=${businessType}`;
        }
        window.axios
            .get(url)
            .then((response) => {
                setData(response.data.data)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };

    const handleChange = (event, questionId) => {
        setData(data.map((e) => {
            if (e.questionId === questionId) e.answers = event.target.value;
            return e;
        }))
    }

    const handleChangeTextResult = (value, questionId) => {
        setData(data.map((e) => {
            if (e.questionId === questionId) e.answers = value;
            return e;
        }))
    }

    return (
        <Box>
            <SelectField
                required={true}
                placeholder="Business Type"
                options={BUSINESS}
                value={businessType}
                onChange={(value) => setBusinessType(value)}
            />
            <Divider/>
            <AlertBar ref={alert}/>
            <Stack spacing={2} sx={{p: 2}}>
                {data.map((e, index) => (
                    e.questionType === "Radio" ?
                        <FormControl key={e.questionId}>
                            <FormLabel id="demo-row-radio-buttons-group-label">{index + 1}. {e.name}</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                onChange={(event) => handleChange(event, e.questionId)}
                            >
                                {e.choises.map((c) => (
                                    <FormControlLabel
                                        sx={{pl: 2}}
                                        value={`${c.answer?.name}`}
                                        control={<Radio/>}
                                        label={`${c.answer?.name}`}
                                    />
                                ))}
                            </RadioGroup>
                        </FormControl> :
                        <InputField
                            key={e.questionId}
                            required={true}
                            label={`${index + 1}. ${e.name}`}
                            type="text"
                            multiline={true}
                            onChange={(value) => handleChangeTextResult(value, e.questionId)}
                        />
                ))}
            </Stack>
        </Box>
    );
}